import {AbstractStorage} from "./AbsctractStorage";

export class CookiesStorage extends AbstractStorage {
    constructor(path, domain, secure, expires) {
        super();
        this.path = " ; path=" + path;
        this.domain = " ; domain=" + domain;
        this.secure = secure ? "; secure" : "";
        this.expires = expires !== undefined ? " ; expires=" + expires.toUTCString() : "";
    }
    set(key, value) {
        const cookie = key + "=" + value;
        document.cookie = cookie + this.path + this.domain + this.secure + this.expires;
    }
    get(key) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + key + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }
    remove(key) {
        document.cookie = key + "=" + this.path + this.domain + this.secure + ";expires=Thu, 01 Jan 1970 00:00:00 UTC"
    }
    getAll() {
        return document.cookie;
    }
}


// WEBPACK FOOTER //
// ./src/storage/CookiesStorage.js